import type { MeResponse } from '../../../entities/me/me-contract.types';
import { resolveFirstAllowedRoute } from '../../../shared/access/route-resolver';

import type { StaffAuthMeRefreshOptions } from '../../../shared/auth/auth-context';

export type StaffImpersonationEnterDeps = {
  organizationId: number;
  /** Явный путь после входа; иначе — первый разрешённый tenant-маршрут из `me.capabilities`. */
  landingPath?: string;
  setImpersonateOrgId: (organizationId: number | null) => Promise<void>;
  refreshMe: (opts?: StaffAuthMeRefreshOptions) => Promise<MeResponse | null>;
  navigate: (to: string, opts?: { replace?: boolean }) => void;
};

/** Общий порядок: заголовок имперсонации → refetch `/auth/me` → переход в tenant shell. */
export async function staffImpersonationEnterOrganization(deps: StaffImpersonationEnterDeps): Promise<void> {
  await deps.setImpersonateOrgId(deps.organizationId);
  const me = await deps.refreshMe();
  const target = deps.landingPath ?? resolveFirstAllowedRoute(me?.capabilities ?? null, me);
  deps.navigate(target, { replace: true });
}
